import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { StripeTaxRate } from "./types";
import { CATALOG_TAX_RATES_QUERY_KEY } from "./use-tax-rates-list";

async function archiveTaxRate(id: string): Promise<StripeTaxRate> {
  return httpClient<StripeTaxRate>(
    `/api/admin/catalog/tax-rates/${encodeURIComponent(id)}/archive`,
    { method: "POST" },
  );
}

export function useArchiveTaxRate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: archiveTaxRate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATALOG_TAX_RATES_QUERY_KEY });
    },
  });
}
